import React from 'react'
import PropTypes from 'prop-types'
import SearchForm from './../../shared/components/searchForm/SearchForm';
import { ruleSearchFields } from '../utils/searchFields';
import DataTable, {possibleStatus} from './../../shared/components/table/DataTable';
import { I18n } from 'react-redux-i18n';
import { appModules } from '../../roles/components/UserHasPermission'
import SwitchField from "../../shared/components/fields/switchField/SwitchField";

const RulesPage = ({
    searchFieldsValues,
    universalSearchField,
    handleSearchFieldChange,
    handleUniversalSearchFieldChange,
    handleSearchSubmit,
    handleSearchClear,
    handleSortChanged,
    handleAddButtonClicked,
    entityList = [],
    data = [],
    pages = 0,
    currentPage = 0,
    pageSize,
    totalElements,
    sort: {
        property = "",
        direction = "ASC"
    },
    onRowClick,
    onPageChange,
    onPageSizeChange,
}) => {

    const columns = [{
        Header: I18n.t("rules.list.type"),
        id: "type",
        accessor: rule => I18n.t("rules.types." + rule.type),
        sortable: true
    }, {
        Header: I18n.t("rules.list.name"),
        accessor: "name",
        sortable: true
    }, {
        Header: I18n.t("rules.list.description"),
        accessor: "description",
        sortable: true
    }, {
        Header: I18n.t("rules.list.status"),
        id: "status",
        accessor: (rule) => (
                <SwitchField
                    noLegend={true}
                    checked={getStatusSwitchFieldState(rule.status)}
                    disabled={true}
                />
        ),
        sortable: false
    }];

    return <div className="page_background">
        <SearchForm
            content={ruleSearchFields(searchFieldsValues, entityList)}
            universalSearchField={universalSearchField}
            handleFieldChange={handleSearchFieldChange}
            handleUniversalSearchFieldChange={handleUniversalSearchFieldChange}
            handleClear={handleSearchClear}
            handleSubmit={handleSearchSubmit}
            handleAddButtonClicked={handleAddButtonClicked}
            appModule={appModules.RULE}
        />
        <div>
            <DataTable
                //State dependent
                data={data}
                onRowClick={onRowClick}

                //Pagination
                pages={pages}
                selectedPage={currentPage}
                pageSize={pageSize}
                sortDirection={direction}
                sortProperty={property}
                totalElements={totalElements}
                pageSizeOptions={[10, 20, 50]}
                onPageChange={onPageChange}
                onPageSizeChange={onPageSizeChange}
                onSortChanged={handleSortChanged}

                //State independent / Configuration
                hasRowSelector={true}
                columns={columns}
                hasStatusBar={true}
                statusBarAccessor={rule => {
                    switch (rule.status) {
                        case "ENABLED":
                            return possibleStatus.active;
                        case "DISABLED":
                            return possibleStatus.inactive;
                        default:
                            return possibleStatus.uncertain;
                    }
                }}
            />
        </div>
    </div>
};

function getStatusSwitchFieldState(status) {
    switch(status) {
        case "ENABLED":
            return true;
        case "DISABLED":
            return false;
        default:
            return false;
    }
}

RulesPage.propTypes = {
    searchFieldsValues: PropTypes.object.isRequired,
    handleSearchFieldChange: PropTypes.func,
    handleSearchSubmit: PropTypes.func,
    handleSearchClear: PropTypes.func,
    entityList: PropTypes.array,
    data: PropTypes.array,
    pages: PropTypes.number,
};

export default RulesPage;